import { Edge } from "@xyflow/react";

export default function hasParent(edges: Edge[], id: string) {
  const nonZapStepEdges = edges.filter((edge) => edge.type !== "zapStepEdge");
  return Boolean(nonZapStepEdges.find((edge) => edge.target === id));
}
